import React, { useRef, useState } from "react";
import { Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import { ErrorMessage, useForm } from "react-hook-form";
import { connect } from "react-redux";
import * as Yup from "yup";



// components
import { ButtonCancel, ButtonSubmit, GenericTableButton } from "../../../components/buttons/buttonsActions";
import { LogHistoryModal } from "../../../components/logHistory/logHistoryModal";

// labels
import {
    FORM, LB_ACTIVE, LB_IS_TRANSLATABLE,
    MAX_NAME,
    REQUIRED
} from "../../../components/i18n/i18n";
import { MAX_NAME_SIZE } from "../../../components/menu-flower/constants";
import { TT_HISTORY } from "../../../components/i18n/toolTips";

// actions
import { setLoading, setViewMode } from "../../../redux/actions/generalActions/mainActions";
import { resetCombos, setForm, setItem } from "../../../redux/actions/generalActions/formActions";
import { genericActions } from "../../../redux/actions/generics/GenericActions";

// services
import { applicativeService } from "../../../jwt/_services/firebase/applicativeService";
import {
    FL_CLOUD_MESSAGE_ID,
    FL_CODE,
    FL_DATA_BASE,
    FL_DESCRIPTION,
    FL_NAME,
    FL_PROJECT
} from "../../../components/i18n/formLabels";
import {PH_CLOUD_MESSAGE_ID, PH_CODE, PH_DESCRIPTION, PH_NAME} from "../../../components/i18n/placeHolders";
import SelectGeneric from "../../../components/select/selectGeneric";
import {fbProjectProvider} from "../../../providers/fbProjectProvider";
import Switch from "react-bootstrap-switch";
import {fbDatabaseProvider} from "../../../providers/fbDatabaseProvider";


const ApplicativeForm = props => {
    const { editMode, disableInputs, domainObject } = props.formProps;

    const [showModal, setShowModal] = useState(true)
    const [fbDatabaseId, setFbDatabaseId] = useState(domainObject?.fbDataBase?.id || null);
    const [isTranslatable, setIsTranslatable] = useState(domainObject?.isTranslatable || false)

    const modalRef = useRef(null);

    
    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME),
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            code: domainObject?.code,
            name: domainObject?.name,
            color: domainObject?.color,
            description: domainObject?.description,
            cloudMessageID: domainObject?.cloudMessageID,
        }
    });

    const onSubmit = (data, _) => {
        let dataRequest = {
            ...data,
            isTranslatable,
        };

        if (fbDatabaseId !== null)
            dataRequest.fbDataBase = { id : fbDatabaseId }

        if (editMode) {
            let id = domainObject.id;
            dataRequest.id = id

            genericActions.update(applicativeService, id, dataRequest)
        } else {
            genericActions.save(applicativeService, dataRequest)
        }


        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose();
    }

    return (<>
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="2">
                            <FormGroup>
                                <Label>{FL_CODE}</Label>
                                <Input type="text" name="code"
                                       placeholder={PH_CODE}
                                       innerRef={register}
                                       disabled={disableInputs}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div" className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{FL_NAME}</Label>
                                <Input type="text"
                                       name="name"
                                       placeholder={PH_NAME}
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>Color</Label>
                                <Input
                                    type="color"
                                    name="color"
                                    innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label>{ FL_DATA_BASE }</Label>
                                <SelectGeneric
                                    initialValue={ fbDatabaseId }
                                    setExternalValue={ setFbDatabaseId }
                                    provider={ fbDatabaseProvider }
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>{LB_IS_TRANSLATABLE}</Label>
                                <br/>
                                <Switch
                                    animate={true}
                                    offText={"No"}
                                    onText={"Si"}
                                    value={isTranslatable}
                                    onChange={() => setIsTranslatable(!isTranslatable)}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <Label>{FL_CLOUD_MESSAGE_ID}</Label>
                                <Input type="text"
                                       name="cloudMessageID"
                                       placeholder={PH_CLOUD_MESSAGE_ID}
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="12">
                            <FormGroup>
                                <Label>{FL_DESCRIPTION}</Label>
                                <Input type="text"
                                       name="description"
                                       placeholder={PH_DESCRIPTION}
                                       innerRef={register}
                                       disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
        </Card>

        {
            showModal && <LogHistoryModal
                ref={ modalRef }
                item={ domainObject }
            />
        }
    </>)
}


const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setViewMode,
    resetCombos,
    setItem,
    setForm,
    setLoading
})

export default connect(mapStateToProps, mapActionsToProps)(ApplicativeForm)